// import '@ant-design/compatible/assets/index.css';


import { useQuery } from 'react-query';
import React, { useCallback, useEffect, useState } from 'react';

import {
  Radio,
  Col,
  Spin,
  Row,
  Typography,
  Divider,
  Select,
  notification,
  message,
  Input,
} from 'antd';
import * as finEngine from 'services/finEngine';
import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';
import FormInput from 'components/FormInput';
import {
  getFinContractById,
  getFinModificationValidByCtrid,
  getFinModificationByModid,
  changeDuration,
  FinConElementResponse,
} from 'services/fincontract';
import SliderWithInput from 'components/SliderWithInput';
import { FormInstance } from 'antd/lib/form';
import InputMoney from 'components/InputMoney';
import TextArea from 'antd/lib/input/TextArea';

import { PricingResponse } from 'services/pricing';
import { dateToString } from 'utils/utils2';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';

const { Text } = Typography;

export type TabContractChangeDurationProps = {
  objectid: number;
  object: string;
  form?: FormInstance;
  setSuccessful?: any;
};

const TabContractChangeDuration = ({
  objectid,
  object,
  form,
  setSuccessful,
}: TabContractChangeDurationProps) => {
  const [state, setState] = useState({
    isLoading: false,
    isModSelected: false,
    newDuration: 0,
    effectDate: '',
    feesAmount: 0,
    feesFormula: '',
    newElements: [] as FinConElementResponse[],
  });

  const { data: contract, isLoading } = useQuery(
    ['getFinContractById', { ctrid: objectid }],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data),
    { refetchOnMount: true }
  );

  const { data: modList, isFetching } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'CHANGEDUR',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  useEffect(() => {
    setSuccessful(isLoading && isFetching);
  }, [isLoading, isFetching]);

  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      updateState({ isModSelected: false });
      return;
    }

    updateState({ isLoading: true });

    let query = getFinModificationByModid({ modid: finmod });

    query.then((response) => {
      if (response.code !== '200') {
        return;
      }

      const res = response.data;
      form?.setFieldsValue({
        mode: 'REAL',
        newDuration: res.simulParams.filter(
          (item) => item.parcode === 'DURATION' && item.partype === 'IN'
        )[0].newvalue,
        effectDate: res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue,
        feesFormulaList: {
          priid: Number(
            res.simulParams.filter(
              (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
            )[0].newvalue
          ),
          prilabel: 'Fees Modification',
        },
        feesFormula: res.simulParams.filter(
          (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
        )[0].newvalue,
        feesAmount: res.simulParams.filter(
          (item) => item.parcode === 'FEESAMNT' && item.partype === 'IN'
        )[0].newvalue,
      });

      handleDurationChange(
        res.simulParams.filter(
          (item) => item.parcode === 'DURATION' && item.partype === 'IN'
        )[0].newvalue
      );

      updateState({ isModSelected: true });

      updateState({ isLoading: false });
    });
  };

  const durationMin = contract?.conElements?.find((e) => e.ctetype === 'FIN')
    ?.pricing?.durationmin;
  const durationMax = contract?.conElements?.find((e) => e.ctetype === 'FIN')
    ?.pricing?.durationmax;
  const durationDefault = contract?.conElements?.find(
    (e) => e.ctetype === 'FIN'
  )?.cteduration;

  const notInvoicedSchedule = contract?.conElements
    ?.find((e) => e.ctetype === 'FIN')
    ?.conElemSchedules.filter((s) => s.ciid === null);
  const offerid = contract?.offerid;

  const optionDates = notInvoicedSchedule?.map(
    (e, index) =>
      e.ctstype !== 'UPFRONT' && (
        <option key={index} value={e.ctsduedate.toString()}>
          {e.ctsduedate}
        </option>
      )
  );

  const optionModListValid = modList?.map((e, index) => (
    <option key={index} value={e.modid}>
      {e.modcomment}
    </option>
  ));

  const optionsMode = [
    { label: 'Simulation', value: 'SIMUL' },
    { label: 'Real', value: 'REAL' },
  ];

  const updateState = useCallback(
    (values:any) => {
      setState((prev) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const handleDurationChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    calculate(objectid, value, 0, '', targetDate);
  };

  const calculateFees = (pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: contract?.conElements[0].conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: contract?.conElements[0].ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.conElements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: contract?.conElements[0].cteduration ?? 0,
          inInvestAmount: contract?.conElements[0].cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0].assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          form?.setFieldsValue({
            feesAmount: res.installmentamount,
            feesFormula: pricing?.priid,
          });
        }
      });
  };

  const calculate = (
    ctrid: number,
    newDuration: number,
    feesAmount: number,
    feesFormula: string,
    effectDate: string
  ) => {
    updateState({ isLoading: true });

    changeDuration({
      ctrid: ctrid,
      taskid: 0,
      newDuration: newDuration,
      modid: 0,
      mode: 'CALCUL',
      invoiceFees: false,
      feesFormula: feesFormula,
      feesAmount: feesAmount,
      effectDate: effectDate,
    })
      .then((response) => {
        updateState({ isLoading: false });
        if (response.code !== '200') {
          notification.error({
            message: response.message,
            duration: 0,
          });
        } else {
          updateState({ newElements: response.data.conElements });
        }
      })
      .catch((err) => {
        message.error(
          'Error in calculation. please contact the service provider'
        );
      });
  };

  return (
    <DF.Provider
      pagcode="tabchangeduration"
      entity={object}
      entityid={objectid}
    >
      <Spin spinning={state.isLoading || isLoading} delay={500}>
        <Row>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              <FormInput col xs={4} name="currentDuration">
                <Text>{durationDefault}</Text>
              </FormInput>
              <FormInput
                col
                xs={20}
                name="newDuration"
                rules={[{ required: true }]}
              >
                <SliderWithInput
                  disabled={state.isModSelected}
                  min={durationMin}
                  max={durationMax ?? 100}
                  precision={0}
                  defaultValue={durationDefault}
                  onChange={handleDurationChange}
                />
              </FormInput>
            </Row>

            <Row gutter={[8, 8]}>
              <FormInput
                col
                xs={6}
                name="effectDate"
                rules={[{ required: true }]}
              >
                <Select
                  defaultValue=""
                  size="small"
                  style={{ width: '100%' }}
                  disabled={state.isModSelected}
                >
                  {optionDates}
                </Select>
              </FormInput>

              <FormInput col xs={0} name="feesFormula" hidden>
                <Input />
              </FormInput>

              <FormInput
                col
                xs={12}
                name="feesFormulaList"
                rules={[{ required: true }]}
              >
                <PricingListFilteredSelect
                  //disabled={!getFieldValue('offerid')}
                  allowClear
                  disabled={state.isModSelected}
                  params={{
                    offerid: offerid ?? 0,
                    ctetype: 'MODFEES', // Modifictaion fees
                    prcode: contract?.prcode ?? '',
                    entity: '',
                    entityid: 0,
                    tpid: contract?.tpidclient ?? 0,
                  }}
                  onChange={(e) => calculateFees(e)}
                />
              </FormInput>
              <FormInput col xs={6} name="feesAmount">
                <InputMoney defaultValue={0} disabled={state.isModSelected} />
              </FormInput>
            </Row>

            <Row gutter={[8, 8]}>
              <FormInput col xs={6} name="mode" rules={[{ required: true }]}>
                <Radio.Group
                  options={optionsMode}
                  defaultValue="SIMUL"
                  optionType="button"
                  disabled={state.isModSelected}
                />
              </FormInput>
              <FormInput col xs={18} name="modid">
                <Select
                  size="small"
                  allowClear
                  style={{ width: '100%' }}
                  onChange={(e: number) => handleFinModSelect(e)}
                >
                  {optionModListValid}
                </Select>
              </FormInput>
            </Row>

            <Row gutter={[8, 8]}>
              <FormInput
                col
                xs={18}
                name="comment"
                rules={[{ required: true }]}
              >
                <TextArea rows={4} />
              </FormInput>
            </Row>

            <Divider orientation="left">Elements</Divider>
            <Row>
              <Col span={20}>
                <Row>
                  <Col span={3}>Element#</Col>
                  <Col span={17}>Label</Col>

                  <Col span={4}>OldRentalAmount</Col>
                </Row>
                {contract?.conElements?.map((el, index) => (
                  <div key={index}>
                    <Row>
                      <Col span={3}>{el.cteorder}</Col>
                      <Col span={17}>{el.ctedescription}</Col>
                      <Col span={4}>
                        {toCurrency(el.cterentalamount, el.currcode)}
                      </Col>
                    </Row>
                  </div>
                ))}
              </Col>
              <Col span={4}>
                <Row>
                  <Col span={24}>NewRentalAmount</Col>
                </Row>
                {[...state.newElements]?.map((elN, indexN) => (
                  <div key={indexN}>
                    <Row>
                      <Col span={24}>
                        {toCurrency(elN.cterentalamount, elN.currcode)}
                      </Col>
                    </Row>
                  </div>
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </DF.Provider>
  );
};
export default TabContractChangeDuration;
